/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mark_As_SoldInputs */

const en_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as Sold`)
};

const es_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como vendido`)
};

const fr_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer comme vendu`)
};

const de_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als verkauft markieren`)
};

const ja_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済みにする`)
};

const zh_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记为已售`)
};

const ar_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديد كمباع`)
};

const id_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tandai sebagai Terjual`)
};

const it_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna come Venduto`)
};

const ru_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметить как проданное`)
};

const pt_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como Vendido`)
};

const ko_mark_as_sold = /** @type {(inputs: Mark_As_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 완료로 표시`)
};

/**
* | output |
* | --- |
* | "Mark as Sold" |
*
* @param {Mark_As_SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mark_as_sold = /** @type {((inputs?: Mark_As_SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mark_As_SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mark_as_sold(inputs)
	if (locale === "es") return es_mark_as_sold(inputs)
	if (locale === "fr") return fr_mark_as_sold(inputs)
	if (locale === "de") return de_mark_as_sold(inputs)
	if (locale === "ja") return ja_mark_as_sold(inputs)
	if (locale === "zh") return zh_mark_as_sold(inputs)
	if (locale === "ar") return ar_mark_as_sold(inputs)
	if (locale === "id") return id_mark_as_sold(inputs)
	if (locale === "it") return it_mark_as_sold(inputs)
	if (locale === "ru") return ru_mark_as_sold(inputs)
	if (locale === "pt") return pt_mark_as_sold(inputs)
	return ko_mark_as_sold(inputs)
});